
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, ScrollText, LineChart, Shield, MessageSquare, Plane } from "lucide-react";
import { Link } from "react-router-dom";
import { useAdminAccess } from "@/hooks/useAdminAccess";
import { useIsMobile } from "@/hooks/use-mobile";
import { LoadingSpinner } from "@/components/ui/loading-spinner"; 

export default function Admin() {
  const { isLoading } = useAdminAccess();
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <div className="container mx-auto py-8 px-4 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="container mx-auto py-6 px-4">
      <h1 className={`font-bold mb-6 ${isMobile ? "text-xl" : "text-3xl"}`}>Admin Dashboard</h1>

      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        <Link to="/admin/airports">
          <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
            <CardHeader className={isMobile ? "px-4 py-3" : ""}>
              <CardTitle className={`flex items-center gap-2 ${isMobile ? "text-base" : ""}`}>
                <Plane className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
                Airports
              </CardTitle>
            </CardHeader>
            <CardContent className={isMobile ? "px-4 pb-4" : ""}>
              <p className="text-sm text-muted-foreground">Manage airport database</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/feedback">
          <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
            <CardHeader className={isMobile ? "px-4 py-3" : ""}>
              <CardTitle className={`flex items-center gap-2 ${isMobile ? "text-base" : ""}`}>
                <MessageSquare className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
                Feedback
              </CardTitle>
            </CardHeader>
            <CardContent className={isMobile ? "px-4 pb-4" : ""}>
              <p className="text-sm text-muted-foreground">Process user feedback and requests</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/reports">
          <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
            <CardHeader className={isMobile ? "px-4 py-3" : ""}>
              <CardTitle className={`flex items-center gap-2 ${isMobile ? "text-base" : ""}`}>
                <LineChart className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
                Reports
              </CardTitle>
            </CardHeader>
            <CardContent className={isMobile ? "px-4 pb-4" : ""}>
              <p className="text-sm text-muted-foreground">View site statistics and reports</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/reviews">
          <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
            <CardHeader className={isMobile ? "px-4 py-3" : ""}>
              <CardTitle className={`flex items-center gap-2 ${isMobile ? "text-base" : ""}`}>
                <ScrollText className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
                Reviews
              </CardTitle>
            </CardHeader>
            <CardContent className={isMobile ? "px-4 pb-4" : ""}>
              <p className="text-sm text-muted-foreground">Moderate and manage user reviews</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/security">
          <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
            <CardHeader className={isMobile ? "px-4 py-3" : ""}>
              <CardTitle className={`flex items-center gap-2 ${isMobile ? "text-base" : ""}`}>
                <Shield className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
                Security
              </CardTitle>
            </CardHeader>
            <CardContent className={isMobile ? "px-4 pb-4" : ""}>
              <p className="text-sm text-muted-foreground">Monitor security events and alerts</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/users">
          <Card className="hover:bg-accent transition-colors cursor-pointer h-full">
            <CardHeader className={isMobile ? "px-4 py-3" : ""}>
              <CardTitle className={`flex items-center gap-2 ${isMobile ? "text-base" : ""}`}>
                <Users className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
                Users
              </CardTitle>
            </CardHeader>
            <CardContent className={isMobile ? "px-4 pb-4" : ""}>
              <p className="text-sm text-muted-foreground">Manage user accounts and permissions</p>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
